// @flow

import { STATUS_DEFAULT, STATUS_LOADING, STATUS_FAILURE, STATUS_SUCCESS } from 'constants/statusConstants';
import {
  FETCH_VIDEOS_CHANNEL_PLAYER_START,
  FETCH_VIDEOS_CHANNEL_PLAYER_SUCCESS,
  FETCH_VIDEOS_CHANNEL_PLAYER_FAILURE,
  FETCH_VIDEOS_PLAYLIST_PLAYER_START
} from 'actions/ffr-tv/youtubeVideosChannelPlayerActions';

import type { YoutubeVideo } from 'types/YoutubeVideo';
import type { Status } from 'types/Status';
import type { ActionType } from 'types/Actions';

export type State = {
  videos: Array<YoutubeVideo>,
  status: Status
};

const initialState: State = {
  videos: [],
  status: STATUS_DEFAULT
};

export default function(state: State = initialState, action: ActionType): State {
  switch (action.type) {
    case FETCH_VIDEOS_PLAYLIST_PLAYER_START:
      return {
        ...state,
        status: STATUS_LOADING
      };
    case FETCH_VIDEOS_CHANNEL_PLAYER_START:
      return {
        ...state,
        status: STATUS_LOADING
      };
    case FETCH_VIDEOS_CHANNEL_PLAYER_SUCCESS:
      return {
        ...state,
        videos: action.payload.videos,
        status: STATUS_SUCCESS
      };
    case FETCH_VIDEOS_CHANNEL_PLAYER_FAILURE:
      return {
        ...state,
        status: STATUS_FAILURE
      };
    default:
      return state;
  }
}
